import * as types from '../constants/ActionTypes';

import _ from 'lodash';

const initialState = {
	corpList: [],
	pagination: {
		pages: {
			current: 1,
			total: 1,
		},
		results: {
			from: 1,
			to: 1,
			total: 1,
		},
	},
	statusKeys: {},
	searchResults: {},
	selectedCorporation: null,
	searchStatusKeys: {},
	isFetching: false,
	redirect: false,
	error: {},
};

export default function corporations(state = initialState, action) {
	switch (action.type) {
		case types.REQUEST_CORP:
		case types.REQUEST_CORP_LIST:
			return {
				...state,
				isFetching: true,
				error: {},
			};

		case types.RECEIVE_CORP:
			return {
				...state,
				selectedCorporation: action.corporation,
				isFetching: false,
			};

		case types.RECEIVE_BUILDER_LIST:
			return {
				...state,
				selectedCorporation: action.list.hasOwnProperty('corporation')
					? action.list.corporation
					: state.selectedCorporation,
				isFetching: false,
			};

		case types.RECEIVE_CORP_LIST: {
			const corporations = action.list.results;

			// Assign the customers, if they exist
			if (action.list.customers) {
				const customers = action.list.customers;

				// Loop through the list of corporations and assign the right customer
				corporations.forEach(corporation => {
					// Find and set the associated customer
					corporation.customer = _.find(customers, { id: corporation.customerId });
				});
			}

			return {
				...state,
				corpList: corporations,
				pagination: action.list.pagination || initialState.pagination,
				isFetching: false,
				error: {},
			};
		}

		case types.RECEIVE_CORP_ERROR:
		case types.RECEIVE_CORP_LIST_ERROR:
			return {
				...state,
				isFetching: false,
				error: action.error,
			};

		case types.SUBMIT_EDIT_CORP:
			return {
				...state,
				corporation: action.corporation,
				isFetching: true,
				updatedCorporationId: null,
				redirect: false,
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'updating',
				},
				error: {
					...state.error,
					update: _.omit(state.error.update, action.key),
				},
			};

		case types.RESOLVE_EDIT_CORP: {
			// Update the corporation in the list
			const corpList = state.corpList.map(corporation => {
				if (corporation.id === action.corporation.id) {
					return { ...corporation, ...action.corporation };
				}

				return corporation;
			});

			return {
				...state,
				corpList,
				updatedCorporationId: action.corporation.id,
				isFetching: false,
				error: {},
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'updated',
				},
			};
		}

		case types.RESOLVE_EDIT_CORP_ERROR:
			return {
				...state,
				statusKeys: {
					...state.statusKeys,
					[action.key]: '',
				},
				isFetching: false,
				error: {
					update: {
						...state.error.update,
						[action.key]: action.error,
					},
				},
			};

		case types.SUBMIT_CREATE_CORP: {
			return {
				...state,
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'creating',
				},
				error: {
					...state.error,
					create: _.omit(state.error.create, action.key),
				},
			};
		}

		case types.RESOLVE_CREATE_CORP: {
			return {
				...state,
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'created',
				},
			};
		}

		case types.RESOLVE_CREATE_CORP_ERROR: {
			return {
				...state,
				statusKeys: _.omit(state.statusKeys, action.key),
				error: {
					create: {
						...state.error.create,
						[action.key]: action.error,
					},
				},
			};
		}

		case types.REQUEST_AUTO_COMPLETE_CORP_LIST: {
			return {
				...state,
				searchStatusKeys: {
					...state.searchStatusKeys,
					[action.key]: true,
				},
				error: {
					...state.error,
					search: _.omit(state.error.search, action.key),
				},
			};
		}

		case types.RECEIVE_AUTO_COMPLETE_CORP_LIST: {
			return {
				...state,
				searchResults: {
					...state.searchResults,
					[action.key]: action.results,
				},
				searchStatusKeys: _.omit(state.searchStatusKeys, action.key),
			};
		}

		case types.RECEIVE_AUTO_COMPLETE_CORP_LIST_ERROR: {
			return {
				...state,
				searchStatusKeys: _.omit(state.searchStatusKeys, action.key),
				searchResults: {
					...state.searchResults,
					[action.key]: [],
				},
				error: {
					...state.error,
					[action.key]: action.error,
				},
			};
		}

		case types.SUBMIT_LINK_CORP: {
			return {
				...state,
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'linking',
				},
				error: {
					...state.error,
					link: _.omit(state.error.link, action.key),
				},
			};
		}

		case types.RESOLVE_LINK_CORP: {
			return {
				...state,
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'linked',
				},
			};
		}

		case types.SUBMIT_UNLINK_CORP: {
			return {
				...state,
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'unlinking',
				},
				error: {
					...state.error,
					link: _.omit(state.error.link, action.key),
				},
			};
		}

		case types.RESOLVE_UNLINK_CORP: {
			return {
				...state,
				statusKeys: {
					...state.statusKeys,
					[action.key]: 'unlinked',
				},
			};
		}

		case types.RESOLVE_LINK_CORP_ERROR:
		case types.RESOLVE_UNLINK_CORP_ERROR: {
			return {
				...state,
				statusKeys: _.omit(state.statusKeys, action.key),
				error: {
					...state.error,
					link: {
						...state.error.link,
						[action.key]: action.error,
					},
				},
			};
		}

		case types.CLEAR_CORP_STATE:
			return {
				...state,
				isFetching: false,
				searchResults: {},
				searchStatusKeys: {},
				statusKeys: {},
				error: {},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/corporations.js